import { render, staticRenderFns } from "./DeliveryOrderProducts.vue?vue&type=template&id=677081d6&scoped=true&"
import script from "./DeliveryOrderProducts.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderProducts.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderProducts.vue?vue&type=style&index=0&id=677081d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677081d6",
  null
  
)

export default component.exports